import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IDropdownProps } from './IDropdownProps'
import React from 'react'
import clsx from 'clsx'
import { useDropdownValidationSchema } from './DropdownValidationSchema'

interface IDropdownFieldProps extends HTMLAttributes<HTMLInputElement>, IDropdownProps {
}

export const SimpleDropdown: FC<IDropdownFieldProps> = (props) => {
    const { id, value: initValue, className, title, disabled, options } = props
    const schema = useDropdownValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <select
            title={title}
            id={id}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            className={clsx(className, "form-select form-select-sm")}>
            <option></option>
            {options?.map(({ value, label }, i) => <React.Fragment key={i}>
                <option value={value}>{label}</option>
            </React.Fragment>)}
        </select>
        {error && <FieldError show={true} message={error} />}
    </>
}
